import { Moment } from 'moment';
import { Control } from 'react-hook-form';

import {
  BackupListV2200BackupsItem,
  BackupSettings200,
} from '@newfold/huapi-js/src/index.schemas';

export interface StartAndEndDateSelectionProps {
  backupsList: BackupListV2200BackupsItem[];
}

export type AccountEvent = {
  date_first?: string;
  site_id?: number | string | null;
  domain_id?: number | string | null;
  event?: string;
};

export type BackupsTopCapSeverity = {
  backgroundColor: string;
  accentColor: string;
  buttonColor: 'error' | 'warning' | 'secondary';
  borderColor: string;
  borderColorBottom: string;
};
export type BackupFrequency = 'daily' | 'weekly' | 'monthly';

/** Day counts offered for backup retention in the management UI (single source of truth). */
export const BACKUP_RETENTION_DAY_OPTIONS = [7, 14, 30, 60, 90] as const;

export type BackupRetentionDays = (typeof BACKUP_RETENTION_DAY_OPTIONS)[number];

/** Retention policy: fixed day counts or unlimited. */
export type BackupRetention = 'unlimited' | BackupRetentionDays;

/** Segmented tabs in Backups Management modal. */
export enum ManagementTab {
  Schedule = 'schedule',
  Email = 'email',
}

export interface BackupsManagementFormValues {
  autoBackupEnabled: boolean;
  scheduleTime: Moment | null;
  frequency: BackupFrequency;
  retention: BackupRetention;
  emailGeneral: boolean;
  emailSuccess: boolean;
  emailFailure: boolean;
  emailStorageLimit: boolean;
}

export type EmailNotificationField = keyof Pick<
  BackupsManagementFormValues,
  'emailGeneral' | 'emailSuccess' | 'emailFailure' | 'emailStorageLimit'
>;

export interface BackupsManagementModalProps {
  open: boolean;
  onClose: () => void;
  defaultValues?: Partial<BackupsManagementFormValues>;
  onSave?: (values: BackupsManagementFormValues) => void | Promise<void>;
  isSaving: boolean;
  backupSettingsDetails: BackupSettings200;
  addonId: number;
  siteId: number;
}

export interface NotificationRowProps {
  titleKey: string;
  descKey: string;
  name: EmailNotificationField;
  control: Control<BackupsManagementFormValues>;
  testId: string;
  isLast?: boolean;
  compact?: boolean;
}

export type RedeemParams = {
  hasProduct: boolean;
  seatsAvailable?: number | null;
  websiteId?: string | number | null;
  databaseId?: string | number | null;
  siteUrl?: string | null;
};
